<app-type-lots-divers *ngIf="getIsDivisible()" id="step4" [uid]="getUid()" [parentForm]="parentForm"
    [disabled]="disabled" [lots]="initial?.lots"></app-type-lots-divers>